import { ReCaptchaCaption } from './ReCaptchaCaption';
import { ReCaptchaProvider } from './ReCaptchaProvider';
import { useReCaptcha } from './useReCaptcha';

type ReCaptchaObject = {
  Provider: typeof ReCaptchaProvider;
  Caption: React.ComponentType;
  useReCaptcha: () => {
    setReCaptchaToken: (actionName: string) => Promise<boolean>;
  };
};

export { useReCaptcha, ReCaptchaProvider, ReCaptchaCaption };

export const ReCaptcha: ReCaptchaObject = {
  Provider: ReCaptchaProvider,
  Caption: ReCaptchaCaption,
  useReCaptcha,
};
